import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useOutletContext } from "react-router-dom";
import {
  fetchRooms,
  showsAndRoomsSliceSelector,
} from "../../../../redux/features/showsAndRoomsSlice";

const Rooms = () => {
  const { organization } = useOutletContext();
  const { id: organizationId } = organization || {};
  const dispatch = useDispatch();
  const roomsState = useSelector((state) => showsAndRoomsSliceSelector(state));
  const { roomsLoading, roomsFetched } = roomsState || {};

  useEffect(() => {
    if (organization && !roomsLoading && !roomsFetched) {
      dispatch(fetchRooms({ organizationId }));
    }
  }, [dispatch, organizationId, organization, roomsLoading, roomsFetched]);

  if (!organization) {
    return;
  }

  return (
    <Box>
      <Outlet context={{ organization: organization }} />
    </Box>
  );
};

export default Rooms;
